import styles from '@styles/components/General/TextInput.module.css';
import { useState } from 'react';


interface TextInputProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    type?: 'text' | 'password';
    error?: string;
    loading?: boolean; // Added loading prop
}

export const TextInput = ({ label, value, onChange, placeholder, error, loading = false }: TextInputProps) => {
    return (
        <div className={styles['main-container']}>
            <div className={styles['input-label-container']}>
                <p className={styles['input-label']}>{label}</p>
            </div>
            <textarea
                className={`${styles['input-container']} ${loading ? styles.skeleton : ''}`}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={!loading && placeholder}
                disabled={loading}
            />
            {error && <span className={styles['error-message']}>{error}</span>}
        </div>
    );
}